// extracted by mini-css-extract-plugin
export default {"infoContainer":"styles_infoContainer__coji4"};